import React from 'react';

import type { TDefaultDesktop } from '../../../models';

export function renderButton(props: TDefaultDesktop) {
    const {
        Button,
        Link,
        buttonId,
        buttonText,
        buttonUrl,
        event,
        sendEvent,
        advCodes = [],
    } = props;

    function sendEventOnClick() {
        if (sendEvent && event) {
            sendEvent(event);
        }
    }

    return (
        buttonUrl &&
        buttonText && (
            <Link advCodes={advCodes} border="hidden" href={buttonUrl}>
                <Button
                    id={buttonId}
                    onClick={event ? sendEventOnClick : undefined}
                    size="s"
                    styler={{ marginTop: 12 }}
                    type="button"
                    view="primary"
                >
                    {buttonText}
                </Button>
            </Link>
        )
    );
}
